import { useEffect } from 'react'
import { serverConfig } from '@/config/server.config'

const TRUST_ARC_SCRIPT_IDS = {
  core: 'trustarc-core',
  optOut: 'trustarc-optout',
  notice: 'trustarc-notice',
} as const

function appendScript({
  id,
  src,
  isAsync = false,
}: {
  id: string
  src: string
  isAsync?: boolean
}) {
  if (document.getElementById(id)) {
    return
  }

  const script = document.createElement('script')
  script.id = id
  script.src = src
  script.async = isAsync
  script.crossOrigin = 'anonymous'
  document.body.appendChild(script)
}

export function TrustArcLoader() {
  useEffect(() => {
    const domain = serverConfig.trustArcDomainIdentifier

    appendScript({
      id: TRUST_ARC_SCRIPT_IDS.core,
      src: `https://consent.trustarc.com/autoblockasset/core.min.js?domain=${domain}`,
    })

    appendScript({
      id: TRUST_ARC_SCRIPT_IDS.optOut,
      src: `https://consent.trustarc.com/autoblockoptout?domain=${domain}`,
    })

    appendScript({
      id: TRUST_ARC_SCRIPT_IDS.notice,
      src: `https://consent.trustarc.com/notice?domain=${domain}&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true&pcookie&irmc=irmlink`,
      isAsync: true,
    })
  }, [])

  return null
}
